const Validations = {
  Required: "Validations.Required",
  Min: "Validations.Min",
  Max: "Validations.Max",
  InvalidEmail: "Validations.InvalidEmail",
  InvalidPersonNumber: "Validations.InvalidPersonNumber",
  InvalidPersonNumberFormat: "Validations.InvalidPersonNumberFormat",
  PersonNumberNotBornYet: "Validations.PersonNumberNotBornYet",
  PersonNumberOver130: "Validations.PersonNumberOver130",
  InvalidDate: "Validations.InvalidDate",
  InvalidTime: "Validations.InvalidTime",
  InvalidAmount: "Validations.InvalidAmount",
  MissingRequiredDimensionType: "Validations.MissingRequiredDimensionType",
  InvalidAmountDimensionType: "Validations.InvalidAmountDimensionType",
  InvoiceDueDateGreaterThanInvoiceDate: "Validations.InvoiceDueDateGreaterThanInvoiceDate",
  InvoiceDeliveryDateGreaterThanInvoiceDate: "Validations.InvoiceDeliveryDateGreaterThanInvoiceDate",
  InvoiceWishedPayDateGreaterThanInvoiceDate: "Validations.InvoiceWishedPayDateGreaterThanInvoiceDate",
  AlreadyExists: "Validations.AlreadyExists",
  Invalid: "Validations.Invalid",
  InvalidPaymentTerms: "Validations.InvalidPaymentTerms",
  InvalidMonthRange: "Validations.InvalidMonthRange",
  PeriodisationEndBeforeStart: "Validations.PeriodisationEndBeforeStart",
  InvalidCharacters: "Validations.InvalidCharacters",
  InvalidPhoneNumber: "Validations.InvalidPhoneNumber",
  InvalidOrgNumber: "Validations.InvalidOrgNumber",
  InvalidClearingNumber: "Validations.InvalidClearingNumber",
  InvalidBankAccount: "Validations.InvalidBankAccount",
  AtLeastOneItem: "Validations.AtLeastOneItem",
  OnePaymentOptionMustBeDefault: "Validations.OnePaymentOptionMustBeDefault",
  EmailNotUnique: "Validations.EmailNotUnique",
  CurrencyMarkUpMax: "Validations.CurrencyMarkUpMax",
  ToDateLessThanFromDate: "Validations.ToDateLessThanFromDate",
  MaxAmountLessThanMinAmount: "Validations.MaxAmountLessThanMinAmount",
  OnlyOneUploadAllowed: "Validations.OnlyOneUploadAllowed",
  InvalidPhone: "Validations.InvalidPhone",
  InvalidFullName: "Validations.InvalidFullName",
  NoDuplicates: "Validations.NoDuplicates",
  ShouldBeFutureDate: "Validations.ShouldBeFutureDate",
  InvoiceStartDateGreaterThanStopDate: "Validations.InvoiceStartDateGreaterThanStopDate",
  TimeReportingIntervalMustBeSetWhenIsTimeReportingMandatory: "Validations.TimeReportingIntervalMustBeSetWhenIsTimeReportingMandatory",
  MinAmountMustBeLargerOrEqualToZero: "Validations.MinAmountMustBeLargerOrEqualToZero",
  EndDateMustBeLaterThanStartDate: "Validations.EndDateMustBeLaterThanStartDate",
  DateNotWithinStartDateAndEndDate: "Validations.DateNotWithinStartDateAndEndDate",
  ValueTooLong: "Validations.ValueTooLong",
  ChangeSalaryDateMustBeLaterThanEmploymentDate: "Validations.ChangeSalaryDateMustBeLaterThanEmploymentDate",
  RehireStartDateMustBeAfterEndDate: "Validations.RehireStartDateMustBeAfterEndDate",
  OrgNumberInvalidLength: "Validations.OrgNumberInvalidLength",
  InvalidMinutesRange: "Validations.InvalidMinutesRange",
  AccuralDateFallInPeriodisationPeriod: "Validations.AccuralDateFallInPeriodisationPeriod",
  FormSubmitFailed: "Validations.FormSubmitFailed",
  FormContainsErrors: "Validations.FormContainsErrors",
  DirectDebitCantHaveAccount: "Validations.DirectDebitCantHaveAccount",
  InvalidNumberRange: "Validations.InvalidNumberRange",
  OneOfRequired: "Validations.OneOfRequired",
  InvalidInvoiceQuantity: "Validations.InvalidInvoiceQuantity",
  ImportFileNoData: "Validations.ImportFileNoData",
  ImportFileEmpty: "Validations.ImportFileEmpty",
  MustBePositive: "Validations.MustBePositive",
  MustNotBeZero: "Validations.MustNotBeZero",
  }
export default Validations;